import React from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../../store/auth-context";
import ACard from "../../Materials/ACard";
import classes from "../../../styles/Login.module.css";

const Login = () => {
  const emailRef = React.useRef();
  const passwordRef = React.useRef();
  const [isLoading, setIsLoading] = React.useState(false);
  const authCtx = React.useContext(AuthContext);
  const navigation = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    const enteredEmail = emailRef.current.value;
    const enteredPassword = passwordRef.current.value;
    emailRef.current.value = "";
    passwordRef.current.value = "";
    if (
      enteredEmail.trim().length === 0 ||
      enteredPassword.trim().length === 0
    ) {
      alert("Please enter email and password");
      return;
    }

    setIsLoading(true);
    try {
      const res = await fetch(
        "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBl_25ukyu4KjPpOcY9EkehUIX0qChNTO0",
        {
          method: "POST",
          body: JSON.stringify({
            email: enteredEmail,
            password: enteredPassword,
            returnSecureToken: true,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setIsLoading(false);
      if (!res.ok) {
        return res.json().then((data) => {
          if (data || data.error || data.error.message)
            alert(data.error.message);
          throw new Error(data.error.message);
        });
      }
      navigation('/blog', { replace: true });
      const data = await res.json();
      authCtx.login(data.idToken);
    } catch (err) {
      // console.log(err.message);
      alert("Error: " + err.message);
    }
  };

  return (
    <section className={classes.auth}>
        <h1>Login</h1>
      <form onSubmit={submitHandler}>
        <div className={classes.control}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email"
            ref={emailRef}
            autoComplete="none"
          />
        </div>
        <div className={classes.control}>
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Password"
            ref={passwordRef}
          />
        </div>
        <div className={classes.actions}>
          <Link to="/signup">Create a new account</Link>
          <button type="submit">
            {!isLoading && "Login"}
            {isLoading && "Logging..."}
          </button>
        </div>
      </form>
    </section>
  );
};

export default Login;
